"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All translations related to opening hours
var OpeningHours = {
  add_oh: {
    nl: 'Voeg een nieuwe tijdtabel toe',
    fr: "Ajouter un nouvel horaire",
    en: 'Add a new timetable'
  },
  no_oh_add: {
    nl: 'Momenteel hebben we nog geen openingsuren ontvangen voor jouw onderneming.',
    fr: "Actuellement, nous n'avons pas encore reçu les heures d'ouverture de votre entreprise.",
    en: 'Currently, we have not yet received any opening hours for your company.'
  },
  open247: {
    nl: 'Open 24/7',
    fr: 'Ouvert 24/7',
    en: 'Open 24/7'
  },
  openClosed: {
    nl: 'Open / Gesloten',
    fr: 'Ouvert / Fermer',
    en: 'Open / Closed'
  },
  holidays: {
    nl: 'Feestdagen',
    fr: 'Jours fériés',
    en: 'Holidays'
  },
  showroom: {
    nl: 'Toonzaal',
    fr: "Salle d'exposition",
    en: 'Showroom'
  },
  shop: {
    nl: 'Winkel',
    fr: 'Magasin',
    en: 'Shop'
  },
  office: {
    nl: 'Kantoor',
    fr: 'Bureau',
    en: 'Office'
  },
  deskoffice: {
    nl: 'Bureau',
    fr: 'Bureau',
    en: 'Desk office'
  },
  workspace: {
    nl: 'Werkplaats',
    fr: 'Espace de travail',
    en: 'Workspace'
  },
  vacation: {
    nl: 'Vakantiedagen',
    fr: 'Vacances',
    en: 'Vacation'
  },
  appointment: {
    nl: 'Op afspraak',
    fr: 'Rendez-vous',
    en: 'Appointment'
  },
  selfservice: {
    nl: 'Self-service',
    fr: 'Self-service',
    en: 'Self-service'
  },
  open247message: {
    nl: 'Wij zijn 24/7 open',
    fr: 'Nous sommes ouverts 24/7',
    en: 'We are open 24/7'
  },
  monday: {
    nl: 'maandag',
    fr: 'lundi',
    en: 'Monday'
  },
  tuesday: {
    nl: 'dinsdag',
    fr: 'mardi',
    en: 'Tuesday'
  },
  wednesday: {
    nl: 'woensdag',
    fr: 'mercredi',
    en: 'Wednesday'
  },
  thursday: {
    nl: 'donderdag',
    fr: 'jeudi',
    en: 'Thursday'
  },
  friday: {
    nl: 'vrijdag',
    fr: 'vendredi',
    en: 'Friday'
  },
  saturday: {
    nl: 'zaterdag',
    fr: 'samedi',
    en: 'Saturday'
  },
  sunday: {
    nl: 'zondag',
    fr: 'dimanche',
    en: 'Sunday'
  },
  easter: {
    nl: 'Pasen',
    fr: 'Pâques',
    en: 'Easter'
  },
  easterMonday: {
    nl: 'Paasmaandag',
    fr: 'Lundi de Pâques',
    en: 'Easter Monday'
  },
  laborday: {
    nl: 'Dag van de Arbeid',
    fr: 'Fête du travail',
    en: 'Labor Day'
  },
  ascensionDay: {
    nl: 'Hemelvaartsdag',
    fr: "Jour de l'ascension",
    en: 'Ascension Day'
  },
  pentecost: {
    nl: 'Pinksteren',
    fr: 'Pentecôte',
    en: 'Pentecost'
  },
  whitsunMonday: {
    nl: 'Pinksteren maandag',
    fr: 'Lundi de Pentecôte',
    en: 'Whitsun Monday'
  },
  DayOfTheFlemishCommunity: {
    nl: 'Feest van de Vlaamse Gemeenschap',
    fr: 'Jour férié de la communauté Flamande',
    en: 'Day Of The Flemish Community'
  },
  belgianNationalDay: {
    nl: 'Nationale Feestdag',
    fr: 'Fête nationale',
    en: 'Belgian National Day'
  },
  assumptionOfMary: {
    nl: 'OLV Hemelvaart',
    fr: 'Assomption',
    en: 'Assumption of Mary'
  },
  dayOfTheWalloonRegion: {
    nl: 'Feest van het Waalse Gewest',
    fr: 'Fête de la Région wallonne',
    en: 'Day of the Walloon Region'
  },
  halloween: {
    nl: 'Halloween',
    fr: 'Halloween',
    en: 'Halloween'
  },
  allSoulsDay: {
    nl: 'Allerzielen',
    fr: 'Toussaint',
    en: "All Souls' Day"
  },
  armistice: {
    nl: 'Wapenstilstand',
    fr: 'Armistice',
    en: 'Armistice'
  },
  kingsFeast: {
    nl: 'Koningsdag',
    fr: 'Fête du Roi',
    en: "King's Feast"
  },
  dayGermanSpeakingCommunity: {
    nl: 'Dag van de Duitstalige Gemeenschap',
    fr: 'Fête de la Communauté Germanophone',
    en: 'Day of the German-speaking Community'
  },
  christmasEve: {
    nl: 'Kerstavond',
    fr: 'Réveillon de Noël',
    en: 'Christmas Eve'
  },
  christmasDay: {
    nl: 'Kerstdag',
    fr: 'Le jour de Noël',
    en: 'Christmas Day'
  },
  newYearsEve: {
    nl: 'Oudjaarsavond',
    fr: 'Réveillon de Nouvel An',
    en: "New Year's Eve"
  },
  newYearsDay: {
    nl: 'Nieuwjaarsdag',
    fr: "Le jour de Nouvel An",
    en: "New Year's Day"
  },
  jan: {
    nl: 'Jan',
    fr: "Jan",
    en: "Jan"
  },
  feb: {
    nl: 'Feb',
    fr: "Fév",
    en: "Feb"
  },
  mar: {
    nl: 'Mrt',
    fr: "Mars",
    en: "Mar"
  },
  apr: {
    nl: 'Apr',
    fr: "Avr",
    en: "Apr"
  },
  may: {
    nl: 'Mei',
    fr: "Mai",
    en: "May"
  },
  jun: {
    nl: 'Jun',
    fr: "Juin",
    en: "Jun"
  },
  jul: {
    nl: 'Jul',
    fr: "Juil",
    en: "Jul"
  },
  aug: {
    nl: 'Aug',
    fr: "Août",
    en: "Aug"
  },
  sep: {
    nl: 'Sept',
    fr: "Sept",
    en: "Sep"
  },
  oct: {
    nl: 'Okt',
    fr: "Oct",
    en: "Oct"
  },
  nov: {
    nl: 'Nov',
    fr: "Nov",
    en: "Nov"
  },
  dec: {
    nl: 'Dec',
    fr: "Dec",
    en: "Dec"
  },
  oh_info: {
    nl: 'Selecteer een tijdsblok voor meer info',
    fr: "Sélectionnez un bloc de temps pour plus d'informations",
    en: "Select a timeblock for more info"
  }
};
var _default = OpeningHours;
exports["default"] = _default;